import React from 'react';
import WinsLosses from './wins-losses';
import Positions from './positions';
import Advice from './advice';
import Teammates from './teammates';
import Rivals from './rivals';
import PlayTime from './play-time';

const Stats = {
  Results: props => <WinsLosses {...props} />,
  Positions: props => <Positions {...props} />,
  Advice: props => <Advice {...props} />,
  Teammates: props => <Teammates {...props} />,
  Rivals: props => <Rivals {...props} />,
  PlayTime: props => <PlayTime {...props} />,
};

export default Stats;
